<template>
  <div>
    <CreateOrEditBuyerPurchase ref="createOrEditDialog" @submitDialog="GetTableList" />
    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item v-if="SearchData.quality_type == 1">
          {{ l("求购管理") }}
        </el-breadcrumb-item>
        <el-breadcrumb-item v-else-if="SearchData.quality_type == 2">
          {{ l("零切管理") }}
        </el-breadcrumb-item>
        <el-breadcrumb-item v-else-if="SearchData.quality_type == 3">
          {{ l("锻件管理") }}
        </el-breadcrumb-item>
        <el-breadcrumb-item v-else-if="SearchData.quality_type == 4">
          {{ l("机加工") }}
        </el-breadcrumb-item>
      </el-breadcrumb>

      <div class="HeaderButtons">
        <el-button v-if="$store.getters.checkPermission('buyer_purchase.edit')" type="success" size="small"
          @click="onlineBatch">{{ l("上架") }}</el-button>
        <el-button v-if="$store.getters.checkPermission('buyer_purchase.edit')" type="danger" size="small"
          @click="offlineBatch">{{ l("下架") }}</el-button>
        <el-button v-if="$store.getters.checkPermission('buyer_purchase.add')" type="primary" icon="el-icon-plus"
          size="small" @click="CreateItem({ quality_type: SearchData.quality_type })">
          <template v-if="SearchData.quality_type == 1">
            {{ l("发布") }}{{ l("原料求购") }}
          </template>
          <template v-else-if="SearchData.quality_type == 2">
            {{ l("发布") }}{{ l("零切求购") }}
          </template>
          <template v-else-if="SearchData.quality_type == 3">
            {{ l("发布") }}{{ l("锻件定制") }}
          </template>
          <template v-else-if="SearchData.quality_type == 4">
            {{ l("发布") }}{{ l("机加工") }}
          </template>
        </el-button>
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="4">
          <label>{{ l("标题") }}</label>
          <el-input :placeholder="l('请输入') + l('标题')" v-model="SearchData.title" clearable @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"></el-input>
        </el-col>

        <el-col :span="4">
          <label>{{ l("状态") }}</label>
          <el-select clearable v-model="SearchData.status" @change="GetTableList(true)">
            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-checkbox :label="l('我发布的')" v-model="SearchData.created_by_me" :true-label="1" :false-label="0"
            @change="GetTableList(true)" style="margin-top:30px;"></el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="el-icon-search" round @click="GetTableList(true)">{{ l("查询") }}</el-button>
        </el-col>
      </el-row>

      <el-table :data="TableList" :stripe="true" @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange">
        <TableOperation :width="90" :operationList="[
          {
            is_show: () => true,
            label: l('详情'),
            command: 'ViewItem',
          },
        ]" @handleOperation="HandleOperation" />

        <!-- {
              is_show: (row) =>
                this.$store.getters.checkPermission('buyer_purchase.edit') &&
                row.status == -1,
              label: '上架',
              command: 'onlineItem',
            },
            {
              is_show: (row) =>
                this.$store.getters.checkPermission('buyer_purchase.edit') &&
                row.status == 1,
              label: '下架',
              command: 'offlineItem',
            }, -->
        <el-table-column type="selection" width="55"
          :selectable="row => row.create_user_id == this.$store.state.session.user.id"> </el-table-column>

        <!-- <el-table-column label="图片" width="100">
          <template slot-scope="scope">
            <div class="ImageInTable">
              <el-image
                v-if="scope.row.img_array[0]"
                :src="scope.row.img_array[0]"
                fit="contain"
                :preview-src-list="scope.row.img_array"
              ></el-image>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column :label="l('标题')" min-width="150" show-overflow-tooltip>

          <template slot-scope="scope">
            <div class="ViewLink" @click="goHomePurchaseDetail(scope.row)">
              {{ scope.row.title }}
            </div>
          </template>

        </el-table-column>

        <el-table-column v-if="SearchData.quality_type == 3" key="forge_type" :label="l('类型')" width="100">
          <template slot-scope="scope">
            {{
              $utils.listFilter(
                $store.state.basicInfo.forge_typeList,
                scope.row.forge_type
              )
            }}
          </template>
        </el-table-column>

        <el-table-column :label="l('数量')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.specification_amount[0].amount
            }}{{ l(scope.row.specification_amount[0].unit) }}
          </template>
        </el-table-column>
        <el-table-column :label="l('状态')" width="100">
          <template slot-scope="scope">
            <div :class="[
              $utils.listFilter(statusList, scope.row.status, 'class'),
            ]">
              {{ $utils.listFilter(statusList, scope.row.status) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="l('截止日期')" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.is_expire" style="color: #999">{{
              l("已截止")
            }}</span>
            <span v-else>{{ scope.row.expire_time.slice(0, 10) }}</span>
          </template>
        </el-table-column>

        <el-table-column key="auth_count" :label="l('报价情况')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="scope.row.auth_count">
              <span v-if="scope.row.create_user_id == $store.state.session.user.id" class="ViewLink"
                @click="showBusiness(scope.row)">
                {{scope.row.auth_count }}{{ l("家已报价") }}
              </span>
              <span v-else style="color:#999">{{ scope.row.auth_count }}{{ l("家已报价") }}</span>
            </template>
            <span v-else style="color: #999">{{ l("暂无报价") }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="created_time" :label="l('发布日期')" sortable="custom" width="120">
          <template slot-scope="scope">
            {{ scope.row.created_time.slice(0, 10) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="HandleSizeChange" @current-change="HandleCurrentChange"
        :current-page="CurrentPage" :page-sizes="PageSizeList" :page-size="PageSize"
        layout="total, prev, pager, next, jumper" :total="TotalCount"></el-pagination>
    </div>


    <el-dialog :title="l('报价记录')" :visible.sync="businessDialogVisible" :destroy-on-close="true" width="1200px">
      <BusinessList v-if="businessDialogVisible" :code="detail.code" :title="detail.title" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="businessDialogVisible = false">{{
          l("取 消")
        }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditBuyerPurchase from "./operation/CreateOrEditBuyerPurchase.vue";
import BusinessList from "@/views/home_purchase/BusinessList.vue";

export default {
  name: "BuyerPurchase",
  components: {
    CreateOrEditBuyerPurchase,
    BusinessList,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        title: "",
        category_id: null,
        quality_type: null,
        status: null,
        created_by_me: 1
      },
      Sorting: "-updated_time",
      statusList: [
        {
          id: 1,
          name: this.l("已上架"),
          class: "color-success",
        },
        {
          id: 0,
          name: this.l("待审核"),
          class: "color-warning",
        },
        {
          id: -1,
          name: this.l("已下架"),
          class: "color-danger",
        },
      ],

      businessDialogVisible: false,

      detail: {
        code: "",
        title: "",
      }
    };
  },
  created() {
    if (this.$route.name == "buyer_purchase_material") {
      this.SearchData.quality_type = 1;
    } else if (this.$route.name == "buyer_purchase_piece") {
      this.SearchData.quality_type = 2;
    } else if (this.$route.name == "buyer_purchase_forging") {
      this.SearchData.quality_type = 3;
    } else if (this.$route.name == "buyer_purchase_machining") {
      this.SearchData.quality_type = 4;
    }
  },
  mounted() {
    console.log("route", this.$route);
    //不能放在created里，因此时dialog组件还没created
    if (this.$route.params.command) {
      if (this.$route.params.command == "create") {
        this.CreateItem({
          quality_type: this.SearchData.quality_type,
        });
      }
    }
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/buyer_purchase/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map((item) => {
            item.img_array = JSON.parse(item.img_array);
            return item;
          });
        });
    },
    onlineItem(item) {
      this.$confirm(`${this.l("是否将")}${item.title}${this.l("上架")}?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/buyer_purchase/${item.code}/on/`)
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    onlineBatch() {
      if (!this.MultipleSelection.length) {
        return this.$message.warning(this.l("请在列表中勾选待上架的内容"));
      }
      this.$confirm(
        `${this.l("是否将")}${this.l("选中")}${this.MultipleSelection.length
        }${this.l("项")}${this.l("上架")}?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(
            `/api/buyer_purchase/bulk_on/`,
            this.MultipleSelection.map((item) => {
              return {
                code: item.code,
              };
            })
          )
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    offlineItem(item) {
      this.$confirm(`${this.l("是否将")}${item.title}${this.l("下架")}?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/buyer_purchase/${item.code}/off/`)
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    offlineBatch() {
      if (!this.MultipleSelection.length) {
        return this.$message.warning(this.l("请在列表中勾选待下架的内容"));
      }
      this.$confirm(
        `${this.l("是否将")}${this.l("选中")}${this.MultipleSelection.length
        }${this.l("项")}${this.l("下架")}?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(
            `/api/buyer_purchase/bulk_off/`,
            this.MultipleSelection.map((item) => {
              return {
                code: item.code,
              };
            })
          )
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    showBusiness(item) {
      this.detail.code = item.code;
      this.detail.title = item.title;
      this.businessDialogVisible = true;
    },
    goHomePurchaseDetail(row) {
      if (row.quality_type == 1) {
        this.$openRouter({
          path: `/home/purchase_material/${row.code}`,
        });
      }
      else if (row.quality_type == 2) {
        this.$openRouter({
          path: `/home/purchase_piece/${row.code}`,
        });
      }
      else if (row.quality_type == 3) {
        this.$openRouter({
          path: `/home/purchase_forging/${row.code}`,
        });
      }
      else if (row.quality_type == 4) {
        this.$openRouter({
          path: `/home/purchase_machining/${row.code}`,
        });
      }
    }
  },
};
</script>


<style scoped lang="scss"></style>
